import { selectKeyPath } from '@mdpp/od-belt';
import { useFormikContext } from 'formik';
import React from 'react';
import { SelectableButton } from './SelectableButton';
export function ODBooleanInput(props) {
    var formikContext = useFormikContext();
    var name = props.name, keyPath = props.keyPath, trueString = props.trueString, falseString = props.falseString, minWidth = props.minWidth, minHeight = props.minHeight;
    var _a = formikContext || {}, setFieldValue = _a.setFieldValue, _b = _a.values, values = _b === void 0 ? {} : _b;
    var v = values;
    var boolValue = !!selectKeyPath(keyPath)(v, false);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(SelectableButton, { selected: boolValue, minWidth: minWidth, minHeight: minHeight, onClick: function () { return setFieldValue(name, true); } }, trueString),
        React.createElement(SelectableButton, { selected: !boolValue, minWidth: minWidth, minHeight: minHeight, onClick: function () { return setFieldValue(name, false); } }, falseString)));
}
//# sourceMappingURL=ODBooleanInput.js.map